import React, { useState } from 'react';
import MeetingChatCard from './MeetingChatCard';

export default function MeetingChatCardList({ userId, data, onSelect, selectedIndex }) {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const filteredData = data.filter(chat =>
    chat.UserDetails && chat.UserDetails.some(member => member.id !== userId)
  );

  return (
    <div>
      {filteredData.map((chat) => {
        return (
          <MeetingChatCard
            key={chat.id}
            chat={chat}
            userId={userId}
            isSelected={chat.id === selectedIndex}
            isHovered={chat.id === hoveredIndex}
            onSelect={onSelect}
            onMouseEnter={() => setHoveredIndex(chat.id)}
            onMouseLeave={() => setHoveredIndex(null)}
          />
        );
      })}
    </div>
  );
}

